import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useGetAvailabilityQuery } from 'src/context/api/bidStratTesting/api';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import BidStratTesting from 'src/sections/overview/dashboards/views/activations/bid-strat-testing/bid-strat-testing';
import BidStratTestingUnavailable from 'src/sections/overview/dashboards/views/activations/bid-strat-testing/unavailable';

export default function BrandShieldBidStratTesting() {
  // Re-renders the page in the new language when it changes
  useTranslation();
  const workspace: any = useCurrentWorkspace();
  // Only restricted where the API runs with ENV "preprod" (test client only); the
  // API refuses the switches there anyway, so a failed call does not block the page
  const { data: availability, isLoading } = useGetAvailabilityQuery();
  const restrictedTo = availability?.restricted_to_client ?? null;
  const open = restrictedTo === null || workspace?.bqTable === restrictedTo;

  return (
    <>
      <Helmet>
        <title>Bid Strat Testing</title>
      </Helmet>

      {!isLoading && open && <BidStratTesting />}
      {!isLoading && !open && <BidStratTestingUnavailable testBqTable={restrictedTo} />}
    </>
  );
}
